module.exports = __webpack_public_path__ + "img/medical-prescription.d579d100.png";